import { Injectable } from '@angular/core';
import { StampManagerType } from '@models/imported/SagaBase';
import { CStampCard } from '@models/imported/SagaSchema/CStampCard';
import { IModelService, IObjectChange, ModelService } from '@services/model-factory';

@ModelService(CStampCard)
@Injectable()
export class CStampCardModelService implements IModelService<CStampCard> {
  constructor() {}

  change(change: IObjectChange<CStampCard>) {
    const stamp: CStampCard = change.target;
    if (stamp.StampType === StampManagerType.PreAttributionUnitActivity && stamp.JsonData) {
      stamp.jsonData = JSON.parse(stamp.JsonData);
    }
  }
}
